const NO_STACK_MSG = 'Stack trace is not available for this type of error.';

export interface ISosErrorTransferObject {
	type: string;
	code: string;
	message: string;
	suggestion?: string;
	stackTrace?: string;
	pathToDocs?: string;
	origin?: string;
	originStack?: string;
}

export function createError(errorTransferObject: ISosErrorTransferObject): Error {
	const { message } = errorTransferObject;
	const errorToReturn = new Error(message);
	errorToReturn.stack = getEnrichedStack(errorTransferObject);
	errorToReturn.name = errorTransferObject.type;

	Object.keys(errorTransferObject).forEach((key: string) => {
		(errorToReturn as any)[key] = (errorTransferObject as any)[key];
	});

	return errorToReturn;
}

export function getEnrichedStack(error: ISosErrorTransferObject): string {
	const { type, message, code, stackTrace, pathToDocs, origin, originStack } = error;
	const suggestion = getErrorSuggestion(code, error.suggestion, pathToDocs);
	let stringToReturn = '';

	stringToReturn += type + ': ' + message + '\n';
	stringToReturn += 'Code' + ': ' + code + '\n';
	stringToReturn += 'Suggestion' + ': ' + suggestion + '\n';
	stringToReturn += origin ? 'Origin' + ': ' + origin + '\n' : '';
	stringToReturn += originStack
		? 'OriginStack' + ': ' + originStack + '\n'
		: origin && !originStack
			? 'OriginStack' + ': ' + NO_STACK_MSG + '\n'
			: '';
	stringToReturn += stackTrace ? 'Stack' + ': ' + stackTrace : 'Stack' + ': ' + NO_STACK_MSG;

	return stringToReturn;
}

function getErrorSuggestion(code: string, suggestion?: string, pathToDocs?: string): string {
	const DEVELOPER_DOCS_HOST_URL = 'https://developers.signageos.io';
	const BEFORE_LINK_MSG = 'More information on';
	let LINK_TO_ERROR: string;

	if (pathToDocs) {
		LINK_TO_ERROR = `${DEVELOPER_DOCS_HOST_URL}${pathToDocs}`;
	} else {
		LINK_TO_ERROR = `${DEVELOPER_DOCS_HOST_URL}/search?key=error%20${code}`;
	}

	let suggestionToReturn = suggestion ? suggestion + '\n' : '';
	suggestionToReturn += `${BEFORE_LINK_MSG} ${LINK_TO_ERROR}`;

	return suggestionToReturn;
}
